import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
//import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import LaunchIcon from '@material-ui/icons/Launch';

const useStyles = makeStyles(theme => ({
  portrait: {
    paddingBottom: '100%',
    borderRadius: '50%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'top center',
    backgroundColor: '#ddd'
  },
  name: {
    textTransform: 'uppercase',
    letterSpacing: '1px',
    color: "#333"
  },
  position: {
    color: "#333",
    fontWeight: 400
  },
  button: {
    fontSize: '75%'
  }
}));

export default (props) => {
  const classes = useStyles();
  return (
    <Grid container direction="row" alignItems="center" spacing={3}>
      <Grid item xs={2}>
        <div className={classes.portrait} style={{ backgroundImage: `url('${props.config.imageUrl}')`}}></div>
      </Grid>
      <Grid item xs={6}>
        <div>
          <div><h4 className={classes.name}>{props.config.name}</h4></div>
          <div><h6 className={classes.position}>{props.config.position}</h6></div>
        </div>
      </Grid>
      <Grid item xs={4}>
      { props.config.downloadUrl &&
        <Button
          href={props.config.downloadUrl}
          target='_blank'
          variant="contained"
          color="default"
          size="small"
          className={classes.button}
          startIcon={<LaunchIcon />}
          disableElevation
        >
          slides
        </Button>
      }
      </Grid>
    </Grid>
  );
}
